import { render, staticRenderFns } from "./SSelectPropertySettings.vue?vue&type=template&id=71bfb91f"
import script from "./SSelectPropertySettings.vue?vue&type=script&lang=js"
export * from "./SSelectPropertySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports